import Button from "@/components/bricks/button/Button";
import { stringDateToPP } from "../../../util/date";
import { PersonByFirstNameLastNameResponse } from "../../autocomplete/interface";
import {
  TicketHeading,
  TicketRoot,
  TicketSub,
  TicketSubItem,
} from "../../ticket/Ticket";
import { useNavigate } from "react-router-dom";
import { AlertMessage } from "../../AlertMessage";

export default function DuplicatePersonWarning(props: {
  personsWithSameName: PersonByFirstNameLastNameResponse[];
  onCancel: () => void;
  numberOfPersons: number;
}) {
  const { personsWithSameName, onCancel, numberOfPersons } = props;
  const navigate = useNavigate();
  return (
    <AlertMessage
      warningIcon
      heading={`Der findes allerede ${numberOfPersons}
    ${numberOfPersons > 1 ? "personer" : "person"} registreret med det
    samme navn:`}
    >
      <div>
        {personsWithSameName.map((person) => {
          const {
            fuldtNavn,
            id,
            //   kundeNr,

            foedselsDato,
          } = person;
          const personFirma = person.personFirma.find(
            (f) => f.periode.tilDatoInklusiv === "9999-12-31",
          );
          return (
            <TicketRoot
              key={id}
              icon="arrow"
              className="bg-white shadow-sm mb-3"
              onClick={() => {
                navigate(`/person/${id}`, { replace: false });
              }}
            >
              <TicketHeading>
                <h4 className="h5">{fuldtNavn}</h4>
              </TicketHeading>
              <TicketSub>
                <>
                  <TicketSubItem>{stringDateToPP(foedselsDato)}</TicketSubItem>

                  {personFirma && (
                    <>
                      <TicketSubItem> | </TicketSubItem>

                      <TicketSubItem>{personFirma?.firma.navn1}</TicketSubItem>
                    </>
                  )}
                </>
              </TicketSub>
            </TicketRoot>
          );
        })}
      </div>

      <p className="fw-semibold">Vil du oprette en ny person med samme navn?</p>
      <div className="d-flex gap-2 flex-row justify-content-between mt-3">
        <Button color="warning" onClick={onCancel}>
          Annuller
        </Button>
        <Button type="submit" color="warning" outline>
          Ja, gå videre
        </Button>
      </div>
    </AlertMessage>
  );
}
